import { fromPairs, map } from 'lodash/fp';
import React, { ReactNode } from 'react';
import { pipe } from 'ts-opt';
import { OrganizationRoleManagement } from 'api/gen/OrganizationRoleManagement';
import { UserProfileSubjectRoleManagementDtoOrganizationRoleManagement } from 'api/gen/UserProfileSubjectRoleManagementDtoOrganizationRoleManagement';
import { DynamicContent } from './gen-dynamic-content';
import { ManagementOrganizationsTableType } from '../../types/management-organizations';
import { getExpirationColor } from '../../utils/get-expiration-color';
const genDynamicColumns = (roles: Array<OrganizationRoleManagement>, computeFarmsAndCentersTooltip: (farmIds: Array<number> | null, centerIds: Array<number> | null, hasAccessToAllOrganizationCenters: boolean, hasAccessToAllFarms: boolean) => string, onCellClick: (role: OrganizationRoleManagement) => void): Record<string, ReactNode> => pipe(roles, map(role => [role.roleId.toString(), <span key={role.roleId} className={getExpirationColor(role.bindingExpiration)}>
            <DynamicContent key={role.roleId} role={role} computeFarmsAndCentersTooltip={computeFarmsAndCentersTooltip} onCellClick={onCellClick} />
        </span>]), fromPairs);

/**
 * Maps organization-management API rows into the tree-table representation.
 *
 * @param row Source API row with organization access data and role bindings.
 * @param computeFarmsAndCentersTooltip Callback used to build the tooltip text.
 * @param onCellClick Callback invoked when a role cell is activated.
 * @returns The organization-management table row.
 *
 * @example
 * managementOrganizationsRowMapper(row, computeFarmsAndCentersTooltip, handleRoleClick);
 */
export const managementOrganizationsRowMapper = (row: UserProfileSubjectRoleManagementDtoOrganizationRoleManagement, computeFarmsAndCentersTooltip: (farmIds: Array<number> | null, centerIds: Array<number> | null, hasAccessToAllOrganizationCenters: boolean, hasAccessToAllFarms: boolean) => string, onCellClick: (role: OrganizationRoleManagement) => void): ManagementOrganizationsTableType => ({
  id: row.userProfileId,
  username: row.username,
  userProfileId: row.userProfileId,
  roles: row.roles,
  isSubjectMember: row.isSubjectMember,
  ...genDynamicColumns(row.roles, computeFarmsAndCentersTooltip, onCellClick)
});